import { Card, Text } from '@mantine/core'
import Message from '../../i18n/Message'
import Money from './Money'

/** A labelled figure. Pass `kobo` for money or `value` for a count. */
export default function Stat({ label, kobo, value, onClick }) {
  return (
    <Card onClick={onClick} style={onClick ? { cursor: 'pointer' } : undefined}>
      <Text size="sm" c="dimmed">
        <Message id={label} />
      </Text>
      {kobo !== undefined ? (
        <Money kobo={kobo} size="xl" fw={600} heading />
      ) : (
        <Text size="xl" fw={600} ff="var(--mantine-font-family-headings)" className="num">
          {value ?? 0}
        </Text>
      )}
    </Card>
  )
}
